export const OPEN_MODAL = "openModal";
export const CLOSE_MODAL = "closeModal";